<template>
  <UApp :toaster="toaster">
    <NuxtLayout>
      <NuxtPage keepalive />
    </NuxtLayout>
    <MainModalAlert ref="alertModalRef"></MainModalAlert>

    <ClientOnly>
      <Teleport to="#v-image-light-box">
        <MainImageLightbox />
      </Teleport>
    </ClientOnly>
  </UApp>
</template>

<script setup lang="ts">
import type { ToasterProps } from "@nuxt/ui";

const nuxtApp = useNuxtApp();

const alertModalRef = useTemplateRef("alertModalRef");

const toaster = {
  position: "bottom-right",
  progress: false,
  duration: 3000,
  class: "sm:w-[560px]!",
} as ToasterProps;

onMounted(async () => {
  await nextTick();
  if (alertModalRef.value) {
    nuxtApp.provide("alert", alertModalRef.value);
  }
});
</script>
